import { useCallback } from 'react'
import { ScrollTrigger } from '../utils/gsap'
import {
  applyCharOpacityProgress,
  BOARD_MISSION_PIN_VH,
  BOARD_SCRUB,
  BOARD_SLIDE_SWAP_THRESHOLD,
  computeVisionMissionScrollValues,
  getBoardPinStart,
  getPinScrollDistance,
} from '../utils/scrollAnimation'
import { useGsapScroll } from './useGsapScroll'

export function useVisionMissionScroll(trackRef, pinRef, layerRefs, enabled) {
  const setup = useCallback(() => {
    const track = trackRef.current
    const pin = pinRef.current
    const layers = layerRefs.current
    if (!track || !pin) return

    ScrollTrigger.create({
      trigger: track,
      start: getBoardPinStart(),
      end: () => `+=${getPinScrollDistance(BOARD_MISSION_PIN_VH)}`,
      pin,
      pinSpacing: true,
      scrub: BOARD_SCRUB,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      preventOverlaps: true,
      onUpdate: (self) => {
        const values = computeVisionMissionScrollValues(self.progress)

        if (layers.visionPanel) {
          layers.visionPanel.style.transform = `translate3d(0, ${values.visionY}px, 0)`
          layers.visionPanel.style.opacity = String(values.visionOpacity)
          layers.visionPanel.style.pointerEvents = values.visionOpacity < 0.5 ? 'none' : 'auto'
          layers.visionPanel.style.zIndex = values.visionOpacity >= values.missionOpacity ? '2' : '1'
        }

        if (layers.missionPanel) {
          layers.missionPanel.style.transform = `translate3d(0, ${values.missionY}px, 0)`
          layers.missionPanel.style.opacity = String(values.missionOpacity)
          layers.missionPanel.style.pointerEvents = values.missionOpacity < 0.5 ? 'none' : 'auto'
          layers.missionPanel.style.zIndex = values.missionOpacity >= values.visionOpacity ? '2' : '1'
        }

        if (self.progress <= BOARD_SLIDE_SWAP_THRESHOLD) {
          const visionP = self.progress / BOARD_SLIDE_SWAP_THRESHOLD
          applyCharOpacityProgress(layers.visionText, visionP)
        } else {
          applyCharOpacityProgress(layers.visionText, 1)
          const missionP =
            (self.progress - BOARD_SLIDE_SWAP_THRESHOLD) / (1 - BOARD_SLIDE_SWAP_THRESHOLD)
          applyCharOpacityProgress(layers.missionText, missionP)
        }
      },
    })
  }, [trackRef, pinRef, layerRefs])

  useGsapScroll(trackRef, enabled, setup)
}
